export default {
    app_name: "gongsi"
};
